import { api } from '@/lib/api/client'
import type { FetchInstitutionDonorsOptions } from '@/types/institution-donor'

export async function requestInstitutionDonorsExportEmail(
  searchQuery: string,
  filters: Pick<
    FetchInstitutionDonorsOptions,
    'campaign_id' | 'purchase_status' | 'min_spent' | 'max_spent'
  > = {}
): Promise<void> {
  await api.post(
    '/api/institution/donors/export-email',
    {
      q: searchQuery.trim() || null,
      ...(filters.campaign_id !== undefined ? { campaign_id: filters.campaign_id } : {}),
      purchase_status: filters.purchase_status ?? 'all',
      min_spent: filters.min_spent ?? null,
      max_spent: filters.max_spent ?? null,
    },
    { requireAuth: true }
  )
}
